import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { Router } from '@angular/router';
import {
  FundWalletModal,
  RequestWithdrawalModal,
  ViewDetailsModal,
  ChangeBankDetailsModal,
  CloseAccountModal,
  ExportStatementByDateModal,
  ActivateAccountModal,
} from 'src/modules/features/contractor/modals';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';
import { AppFilter } from '@app/shared/models';
import { ConfirmModal } from '@app/shared/modals';

@Component({
  selector: 'app-accounts-row',
  templateUrl: './accounts-row.component.html',
  styleUrls: ['./accounts-row.component.scss'],
})
export class AccountsRowComponent implements OnInit {
  @Input() account: any;
  @Output() refreshEvent = new EventEmitter<any>();
  error: any;
  pending = false;
  filter = new AppFilter({
    sidx: 'dateCreated',
    sord: 'asc',
    _search: false,
  });
  constructor(
    private modalService: SuiModalService,
    private router: Router,
    private walletService: EwalletService
  ) {}

  capitalize(word: string) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  exportStatement() {
    this.pending = true;
    this.walletService
      .exportEWalletTransactions({
        nccId: this.account.nccId,
        currencyId: this.account.currencyId,
        params: this.filter,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          const downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(res);
          downloadLink.download = `EWallet ${this.capitalize(
            this.account.currencyShortName
          )} Statement ${new Date().toLocaleDateString('en-GB')}.xlsx`;
          downloadLink.click();
        },
        (error) => {
          this.error = error.error;
          this.pending = false;
        }
      );
  }

  fundWallet() {
    this.modalService.open(new FundWalletModal(this.account));
  }

  requestWithdrawal() {
    this.modalService
      .open(new RequestWithdrawalModal(this.account))
      .onApprove(() => {
        this.modalService
          .open(
            new ConfirmModal(
              'Withdraw Funds',
              'Your withdrawal request has been received and submitted successfully.',
              ModalSize.Tiny,
              'Okay',
              ''
            )
          )
          .onApprove(() => {
            this.router.navigate([
              '/contractor/wallet/withdrawal-request',
              this.account.currencyId,
            ]);
          });
      })
      .onDeny((openChangeBankDetails: boolean) => {
        if (openChangeBankDetails) {
          this.modalService.open(new ChangeBankDetailsModal(this.account));
        }
      });
  }

  viewBankDetails() {
    this.modalService.open(
      new ViewDetailsModal('View Bank Account Details', this.account)
    );
  }

  changeBankDetails() {
    this.modalService
      .open(new ChangeBankDetailsModal(this.account))
      .onApprove(() => {
        this.modalService
          .open(
            new ConfirmModal(
              'Change Bank Details',
              'Your bank details change request has been received and submitted successfully.',
              ModalSize.Tiny,
              'Okay',
              ''
            )
          )
          .onApprove(() => {
            localStorage.setItem(
              'customerWalletId',
              this.account.customerWalletId
            );
            this.router.navigate([
              '/contractor/wallet/bank-change-request',
              this.account.currencyId,
            ]);
          });
      });
  }

  exportStatementByDate() {
    this.modalService.open(new ExportStatementByDateModal(this.account));
  }

  closeAccount() {
    if (!this.account) return;
    console.log(this.account)
    this.modalService
      .open(new CloseAccountModal(this.account))
      .onApprove((withdrawAllFunds: boolean) => {
        this.refreshEvent.emit();
        // if (withdrawAllFunds) {
        //   this.modalService.open(
        //     new RequestWithdrawalModal(this.account, true)
        //   ).onApprove(() => {
        //     this.modalService
        //       .open(
        //         new ConfirmModal(
        //           'Close Account',
        //           'Your request has been received and submitted successfully. Once approved, your account will be closed.',
        //           ModalSize.Tiny,
        //           'Okay',
        //           ''
        //         )
        //       )
        //      .onApprove(() => {
        //         this.refreshEvent.emit();
        //       })
        //   })
        // }
      })
  }

  activateAccount() {
    this.modalService.open(
      new ActivateAccountModal(this.account, ModalSize.Tiny)
    ).onApprove(() => {
      this.refreshEvent.emit();
    })
  }

  goToTransactions() {
    if (this.account.status == 'ACTIVE') {
      this.router.navigate([
        '/contractor/wallet/transactions',
        this.account.currencyId,
      ]);
    }
  }

  formatAmount(amount: number) {
    return amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  ngOnInit(): void {}
}
